import { logger } from '@src/logger';
import { urlPush } from '../routerHistory';
import { onClickTrackHitCountsForTreatmentNewFilter } from './filterHelpers';
import { Constants } from './constants';
import { BusinessTelemetry } from './businessConstants';
export function handleFilterToggleAction(filterType, filterValue, isActive, href, actionModifier, clickCallback) {
    if (!href) {
        return;
    }
    const data = {
        filterType,
        filterValue,
        isActive,
        filterState: !isActive ? BusinessTelemetry.Filters.Activating : BusinessTelemetry.Filters.Deactivating
    };
    const payload = {
        page: href,
        action: Constants.Telemetry.Action.FilterClick,
        actionModifier: actionModifier,
        details: JSON.stringify(data)
    };
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier,
        page: payload.page
    });
    onClickTrackHitCountsForTreatmentNewFilter(filterValue);
    urlPush(href);
    if (clickCallback) {
        clickCallback();
    }
}
export function handleFilterToggle(filterType, filterValue, isActive, href, actionModifier, clickCallback) {
    return ()=>{
        handleFilterToggleAction(filterType, filterValue, isActive, href, actionModifier, clickCallback);
    };
}
export function getFilterText(context, filter, showExpandedIcon, href) {
    let text = context.loc(filter.locKey ? filter.locKey : filter.LocKey, filter.title ? filter.title : filter.Title);
    // !!! Temporary HACK: If filterText is 'Power BI apps' and we are in consulting services tab,
    // then we make the text 'Power BI'.
    if (text === 'Power BI apps' && href && href.indexOf('consulting-services') > -1) {
        text = 'Power BI';
    }
    if (showExpandedIcon) {
        text += ' >';
    }
    return text;
}
export function keyDownHandler(event, clickHandler) {
    if (event.keyCode === Constants.SystemKey.Space) {
        return clickHandler;
    }
}
